import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { userForgetPassword } from "../../store/actions"

// import images
import logoSm from "../../assets/images/logo-sm.png"
import Footer from "./Footer"

// Auth components
import ConfirmAccountSection from "components/Authentication/ConfirmAccount"
import PasswordSection from "components/Authentication/CreatePassword"

// services
import Authentication from "services/Authentication.service"

const authService = new Authentication()

const ForgetPasswordPage = props => {
  const [success, setSuccess] = useState()
  const [error, setError] = useState()
  const [usernameStage, setUsernameStage] = useState(true)
  const [otpStage, setOtpStage] = useState(false)
  const [passwordStage, setPasswordStage] = useState(false)
  const [disableUsernameBtn, setDisableUsernameBtn] = useState(false)
  const [disableConfirmBtn, setDisableConfirmBtn] = useState(false)
  const [disablePasswordBtn, setDisablePasswordBtn] = useState(false)
  const [user, setUser] = useState(null)
  const [completed, setCompleted] = useState(null)

  useEffect(() => {
    setUser(user)
  }, [user])

  useEffect(() => {
    setError(error)
  }, [error])

  function submitUsername(event, values) {
    //props.userForgetPassword(values, props.history)
    setDisableUsernameBtn(true)
    authService.resetPassword(values).then(resp => {
      if (resp.status) {
        setUser({ email: values.username })
        setUsernameStage(false)
        setOtpStage(true)
        setDisableUsernameBtn(false)
        setError(null)
      } else {
        setError(resp.message)
        setDisableUsernameBtn(false)
      }
    })
  }

  function submitOTP(e, values) {
    console.log(values)
    authService.validateOTP(values).then(resp => {
      setError(null)

      if (resp.status) {
        setError(null)
        setOtpStage(false)
        setPasswordStage(true)
      } else {
        setError(resp.message)
      }
    })
  }

  function submitPassword(e, values) {
    console.log(values)
    authService.createPassword(values).then(resp => {
      if (resp.status) {
        setError(null)
        setPasswordStage(false)
        setCompleted(true)
      } else {
        setError(resp.message)
      }
    })
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Forgot Password | REMA</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-5">
        {usernameStage ? (
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={4}>
                <Card className="overflow-hidden">
                  <div className="bg-primary">
                    <div className="text-primary text-center p-4">
                      <h5 className="text-white font-size-20 p-2">
                        Forgot Password
                      </h5>
                      <a href="index.html" className="logo logo-admin">
                        <img src={logoSm} height="24" alt="logo" />
                      </a>
                    </div>
                  </div>
                  <CardBody className="p-4">
                    {error && error ? (
                      <Alert
                        color="danger"
                        style={{ marginTop: "13px" }}
                        className="mt-5"
                      >
                        {error}
                      </Alert>
                    ) : null}

                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={(e, v) => submitUsername(e, v)}
                    >
                      <div className="mb-3">
                        <AvField
                          name="username"
                          label="Email/Phone"
                          className="form-control"
                          placeholder="Enter email/phone"
                          type="text"
                          required
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                            disabled={disableUsernameBtn}
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    Remember It ?{" "}
                    <Link to="login" className="fw-medium text-primary">
                      {" "}
                      Sign In here{" "}
                    </Link>{" "}
                  </p>
                  <Footer />
                </div>
              </Col>
            </Row>
          </Container>
        ) : null}
        {otpStage ? (
          <ConfirmAccountSection
            user={user}
            error={error}
            errorMsg={error}
            handleValidSubmit={submitOTP}
          />
        ) : null}

        {passwordStage ? (
          <PasswordSection
            user={user}
            error={error}
            errorMsg={error}
            handleValidSubmit={submitPassword}
          />
        ) : null}

        {completed ? <CompletedSection /> : null}
      </div>
    </React.Fragment>
  )
}

const CompletedSection = () => {
  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={4}>
            <Card className="overflow-hidden">
              <div className="bg-primary">
                <div className="text-primary text-center p-4">
                  <h5 className="text-white font-size-20">Reset Password</h5>

                  <a href="#" className="logo logo-admin">
                    <img src={logoSm} height="24" alt="logo" />
                  </a>
                </div>
              </div>
              <CardBody className="p-4">
                <div className="p-3 mt-4">
                  <h3>
                    <Alert color="success">Registration successful</Alert>
                  </h3>
                  <center>
                    <Link to="/login" className="fw-medium text-centerrimary">
                      {" "}
                      Click here to Login
                    </Link>{" "}
                  </center>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func,
}

const mapStatetoProps = state => {
  const { forgetError, forgetSuccessMsg } = state.ForgetPassword
  return { forgetError, forgetSuccessMsg }
}

export default withRouter(
  connect(mapStatetoProps, { userForgetPassword })(ForgetPasswordPage)
)
